<template>
  <div class="home-mobile">
    <div style="background: rgba(249, 249, 249, 1)">
      <Carousel
        v-model="value3"
        :autoplay="true"
        :radius-dot="true"
        trigger="hover"
        arrow="never"
        :autoplay-speed="4000"
      >
        <!--        <CarouselItem>-->
        <!--          <div class="demo-carousel">-->
        <!--            <a href="https://www.redteago.com/" target="_blank">-->
        <!--              <img :src="banner5" />-->
        <!--            </a>-->
        <!--          </div>-->
        <!--        </CarouselItem>-->
        <CarouselItem>
          <div class="demo-carousel">
            <router-link to="/CaaS">
              <img :src="banner1" />
            </router-link>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <router-link to="/RedteaReady">
              <img :src="banner2" />
            </router-link>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <router-link to="/RedteaGo">
              <img :src="banner3" />
            </router-link>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <router-link to="/RedteaSIM">
              <img :src="banner4" />
            </router-link>
          </div>
        </CarouselItem>
      </Carousel>
      <router-link to="/#facts">
        <img
          src="../assets/mobile/-更多.svg"
          style="margin-top: 0.3rem; margin-bottom: 0.2rem"
        />
      </router-link>
    </div>

    <div class="facts" id="facts">
      <div class="facts-1 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number1") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text1") }}</p>
      </div>
      <div class="facts-2 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number2") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text2") }}</p>
      </div>
      <div class="facts-3 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number3") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text3") }}</p>
      </div>
      <div class="facts-4 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number4") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text4") }}</p>
      </div>
      <div class="facts-4 facts-img">
        <p class="facts-title">{{ $t("Home.facts.number5") }}</p>
        <p class="facts-content">{{ $t("Home.facts.text5") }}</p>
      </div>
    </div>

    <div class="power">
      <p class="power-title">{{ $t("Home.title") }}</p>
      <p class="power-content">{{ $t("Home.position") }}</p>
    </div>

    <div class="cores">
      <p class="title">{{ $t("Home.connect.title") }}</p>
      <div class="cores-flexBox">
        <div class="cores-imgBox">
          <img src="../assets/web/Plug & Play Connnectivity.svg" />
          <p class="cores-title">{{ $t("Home.connect.title1") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text1") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Always-on Connectivity.svg" />
          <p class="cores-title">{{ $t("Home.connect.title2") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text2") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Management.svg" />
          <p class="cores-title">{{ $t("Home.connect.title3") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text3") }}</p>
        </div>
        <div class="cores-imgBox">
          <img src="../assets/web/Scalable.svg" />
          <p class="cores-title">{{ $t("Home.connect.title4") }}</p>
          <p class="cores-content">{{ $t("Home.connect.text4") }}</p>
        </div>
      </div>
      <Divider />
    </div>
    <div class="Caas">
      <div class="left">
        <p class="left-title">{{ $t("Home.caas.title") }}</p>
        <p class="left-content">{{ $t("Home.caas.des") }}</p>
      </div>
      <div class="right">
        <div class="img-box img1">
          <div class="align-box">
            <img src="../assets/web/Virtualization.svg" />
          </div>
          <div>
            <p class="right-title">{{ $t("Home.caas.title1") }}</p>
          </div>
        </div>
        <div class="img-box img2">
          <div class="align-box">
            <img src="../assets/web/Abstraction.svg" />
          </div>
          <div>
            <p class="right-title">{{ $t("Home.caas.title2") }}</p>
          </div>
        </div>
        <div class="img-box img3">
          <div class="align-box">
            <img src="../assets/web/Openness.svg" />
          </div>
          <div>
            <p class="right-title">{{ $t("Home.caas.title3") }}</p>
          </div>
        </div>
        <router-link to="/Caas">
          <div class="right-more">{{ $t("LEARN") }}</div>
        </router-link>
      </div>
      <Divider />
    </div>

    <div class="product">
      <div class="product-title">{{ $t("Home.product.title") }}</div>
      <div class="product-content">{{ $t("Home.product.des") }}</div>
      <div class="flex-box">
        <div class="img-box">
          <img src="../assets/web/RedteaGo 1.png" style="width: 1.3rem" />
          <p class="img-title">{{ $t("Home.product.title1") }}</p>
          <router-link to="/RedteaGo">
            <p class="img-more">
              {{ $t("LEARN") }}&nbsp;&nbsp;
              <img src="../assets/mobile/跳转.svg" />
            </p>
          </router-link>
        </div>
        <div class="img-box">
          <img src="../assets/web/Redtea ready.png" />
          <p class="img-title">{{ $t("Home.product.title2") }}</p>
          <router-link to="/RedteaReady">
            <p class="img-more">
              {{ $t("LEARN") }}&nbsp;&nbsp;
              <img src="../assets/mobile/跳转.svg" />
            </p>
          </router-link>
        </div>
        <div class="img-box">
          <img src="../assets/web/RedteaSIM.png" />
          <p class="img-title">{{ $t("Home.product.title3") }}</p>
          <router-link to="/RedteaSIM">
            <p class="img-more">
              {{ $t("LEARN") }}&nbsp;&nbsp;
              <img src="../assets/mobile/跳转.svg" />
            </p>
          </router-link>
        </div>
      </div>
      <Divider />
    </div>

    <div class="about">
      <p class="about-title">{{ $t("Home.aboutTitle") }}</p>
      <p class="about-content">{{ $t("Home.aboutDes") }}</p>
      <router-link to="/about">
        <div class="about-more">{{ $t("LEARN") }}</div>
      </router-link>
    </div>

    <div class="about-redtea">
      <Carousel
        v-model="value2"
        :autoplay="true"
        :autoplay-speed="9000"
        :dots="'none'"
        :arrow="'always'"
      >
        <CarouselItem>
          <div class="demo-carousel">
            <p class="demo-title">{{ $t("Home.say.title") }}</p>
            <p class="demo-content">
              "{{ $t("Home.say.content1") }}
              <a
                href="https://ims.ul.com/rise-virtual-sim-0"
                target="_Blank"
                style="color: rgba(207, 42, 42, 1)"
                >{{ $t("Home.say.click") }}</a
              >"
            </p>
            <p class="demo-name">{{ $t("Home.say.author1") }}</p>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <p class="demo-title">{{ $t("Home.say.title") }}</p>
            <p class="demo-content">
              "{{ $t("Home.say.content2") }}
              <a
                href="https://www.gsma.com/membership/membership-types/associate-membership/"
                target="_Blank"
                style="color: rgba(207, 42, 42, 1)"
                >{{ $t("Home.say.click") }}</a
              >"
            </p>
            <p class="demo-name">{{ $t("Home.say.author2") }}</p>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <p class="demo-title">{{ $t("Home.say.title") }}</p>
            <p class="demo-content">
              "{{ $t("Home.say.content3") }}
              <a
                href="https://globalcarrier.telekom.com/newsroom/events/events/gsma-was5"
                target="_Blank"
                style="color: rgba(207, 42, 42, 1)"
                >{{ $t("Home.say.click") }}</a
              >"
            </p>
            <p class="demo-name">{{ $t("Home.say.author3") }}</p>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <p class="demo-title">{{ $t("Home.say.title") }}</p>
            <p class="demo-content">"{{ $t("Home.say.content4") }}"</p>
            <p class="demo-name">{{ $t("Home.say.author4") }}</p>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <p class="demo-title">{{ $t("Home.say.title") }}</p>
            <p class="demo-content">"{{ $t("Home.say.content5") }}"</p>
            <p class="demo-name">{{ $t("Home.say.author5") }}</p>
          </div>
        </CarouselItem>
      </Carousel>
    </div>

    <!-- ihone esim app跳转模态框 -->
    <Modal v-model="modal33" footer-hide width="70" class="mobile-iphone">
      <Row>
        <Col span="24" class="modal-title">{{ $t("iphoneBox.title") }}</Col>
      </Row>
      <Row>
        <Col class="modal-line"></Col>
      </Row>
      <p class="iphone-title-2">{{ $t("iphoneBox.mtitle1") }}</p>
      <p class="iphone-lists">{{ $t("iphoneBox.mtext1") }}</p>
      <p class="iphone-lists">{{ $t("iphoneBox.mtext2") }}</p>
      <p class="iphone-lists">{{ $t("iphoneBox.mtext3") }}</p>
      <p class="iphone-lists">{{ $t("iphoneBox.mtext4") }}</p>
      <!--      <a href="https://www.redteago.com/" target="_blank">-->
      <!--        <div class="more">{{$t('iphoneBox.more')}}</div>-->
      <!--      </a>-->
      <p class="ch-only">{{ $t("iphoneBox.chOnly") }}</p>
      <div class="mobile-box">
        <img class="mobile-img" src="../assets/手机_mobile.png" />
        <div class="down-img">
          <a
            href="https://apps.apple.com/app/redteago/id1492864476"
            target="_blank"
          >
            <img src="../assets/download_mobile.png" />
          </a>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "home-mobile",
  data() {
    return {
      value3: 0,
      value2: 0,
      modal33: false,
    };
  },
  computed: {
    banner1() {
      return this.$store.state.mbanner1;
    },
    banner2() {
      return this.$store.state.mbanner2;
    },
    banner3() {
      return this.$store.state.mbanner3;
    },
    banner4() {
      return this.$store.state.mbanner4;
    },
    banner5() {
      return this.$store.state.mbanner5;
    },
  },
};
</script>
<style lang="less" scoped>
.home-mobile {
  padding-top: 0.9rem;
  .facts {
    padding-top: 0.4rem;
    .facts-img {
      width: 3.15rem;
      margin: 0.1rem auto;
      padding: 0.1rem 0.25rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0.011rem 0.19rem 0px rgba(0, 0, 0, 0.15);
      border-radius: 0.05rem;
    }
    .facts-title {
      color: rgba(207, 42, 42, 1);
      font-family: "Poppins-Medium";
      font-size: 0.18rem;
    }
    .facts-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      margin: 0 auto 0 auto;
    }
  }
  .power {
    margin: 0.4rem auto;
    padding: 0 0.2rem;
    .power-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      margin-bottom: 0.1rem;
      text-align: left;
    }
    .power-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      text-align: left;
    }
  }
  .cores {
    padding: 0.2rem;
    .title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      margin-bottom: 0.2rem;
      text-align: left;
    }
    .cores-flexBox {
      padding-bottom: 0.2rem;
    }
    .cores-imgBox {
      img {
        width: 0.42rem;
        float: left;
      }
      .cores-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Light";
        font-size: 0.14rem;
        margin: 0.2rem 0 0.1rem 0.62rem;
        text-align: left;
      }
      .cores-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-ExtraLight";
        font-size: 0.12rem;
        text-align: left;
        margin-left: 0.62rem;
      }
    }
  }
  .Caas {
    padding: 0 0.2rem 0.2rem 0.2rem;
    .left {
      .left-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.16rem;
        text-align: left;
      }
      .left-content {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-ExtraLight";
        font-size: 0.12rem;
        text-align: left;
        margin: 0.1rem 0 0.2rem 0;
      }
    }
    .right {
      .align-box {
        img {
          width: 0.46rem;
        }
      }
      .right-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.16rem;
        margin: 0.1rem auto 0.2rem auto;
      }
      .right-more {
        color: rgba(255, 255, 255, 1);
        background-color: rgba(207, 42, 42, 1);
        border-radius: 4px;
        width: 3.15rem;
        height: 0.34rem;
        line-height: 0.34rem;
        font-family: "Poppins-Bold";
        font-size: 0.12rem;
        margin: 0.4rem auto 0.5rem auto;
      }
    }
  }
  .product {
    padding: 0 0.2rem;
    .product-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      text-align: left;
    }
    .product-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      text-align: left;
      margin: 0.1rem auto 0.2rem auto;
    }
    .img-box {
      img {
        width: 1rem;
      }
      .img-title {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-Regular";
        font-size: 0.16rem;
      }
      .img-more {
        color: rgba(207, 42, 42, 1);
        font-family: "Poppins-Bold";
        font-size: 0.12rem;
        margin: 0.1rem 0 0.2rem 0;
        img {
          width: 0.11rem;
        }
      }
    }
    .flex-box {
      margin-bottom: 0.4rem;
    }
  }
  .about {
    padding: 0 0.2rem 0.5rem 0.2rem;
    .about-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      text-align: left;
    }
    .about-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      text-align: left;
      margin: 0.1rem auto 0.2rem auto;
    }
    .about-more {
      color: rgba(255, 255, 255, 1);
      background-color: rgba(207, 42, 42, 1);
      border-radius: 4px;
      width: 3.15rem;
      height: 0.34rem;
      line-height: 0.34rem;
      font-family: "Poppins-Bold";
      font-size: 0.12rem;
      margin: 0.4rem auto 0.5rem auto;
    }
  }
  .about-redtea {
    background: rgba(249, 249, 249, 1);
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    .demo-carousel {
      padding: 0 0.2rem;
    }
    .demo-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
    }
    .demo-content {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      text-align: left;
      margin: 0.1rem auto;
    }
    .demo-name {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-ExtraLight";
      font-size: 0.12rem;
      text-align: right;
    }
  }
}
</style>